<template>
  <RouterView />
</template>

<script>
export default {
  data () {
    return {
      pageTitle: 'Dashboard',
      breadcrumb: {
        name: 'dashboard',
        route: { name: 'manage-carriers-carrier-dashboard', params: { carrierId: this.$route.params.carrierId } }
      }
    }
  }
}
</script>
